module.exports = __webpack_public_path__ + "img/messenger.7fe777fe.svg";